import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {injectIntl} from 'react-intl';

import getErrorMessage from '../utils/getErrorMessage';
import * as authActions from '../actions/auth';

class FlashMessage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false
    };

    this.closeFlashMessage = this.closeFlashMessage.bind(this);
  }

  componentWillMount() {
    setTimeout(() => {
      this.setState({visible: true});
    }, 150);
  }

  componentWillUnmount() {
    authActions.clearErrors(this.props.dispatch);
  }

  closeFlashMessage() {
    this.setState({visible: false});

    setTimeout(() => {
      authActions.clearErrors(this.props.dispatch);
    }, 150);
  }

  render() {
    const {xl, intl} = this.props;
    const visibleClass = this.state.visible ? 'visible' : 'hidden';

    let {message} = this.props;

    message = getErrorMessage(message, intl);

    return (
      <div>
        {xl.captcha.visible !== true &&
          xl.captcha.value === null &&
          xl.chineseCaptcha.visible !== true &&
          xl.chineseCaptcha.values === null && (
            <div
              className={`flash-message flash-message--${visibleClass} flash-message--${
                this.props.type
              }`}
              onClick={this.closeFlashMessage}
            >
              <div className="message">{message}</div>
            </div>
          )}
      </div>
    );
  }
}

FlashMessage.defaultProps = {
  type: 'info'
};

FlashMessage.propTypes = {
  type: PropTypes.oneOf(['success', 'error', 'info']),
  message: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  xl: PropTypes.object.isRequired,
  intl: PropTypes.object
};

export default injectIntl(connect(state => state)(FlashMessage));



// WEBPACK FOOTER //
// ./components/FlashMessage.jsx